import React from 'react';
import { Reveal } from './Reveal';
import { ArrowRight } from 'lucide-react';
import { FloatingMetalButton } from './FloatingMetalButton';
export const FinalCTA = () => {
  return <section className="py-16 md:py-20 px-[5vw] bg-bg relative overflow-hidden text-center" data-id="element-164">
      {/* Floating Metal Buttons */}
      <FloatingMetalButton emoji="🌸" className="metal-cta-left top-1/3 left-[10%]" data-id="element-165" />
      <FloatingMetalButton emoji="💎" className="metal-cta-right top-1/2 right-[10%]" data-id="element-166" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-167">
        <Reveal data-id="element-168">
          <h2 className="font-serif font-bold text-[clamp(40px,6vw,64px)] tracking-[-0.02em] text-ink mb-8 leading-[1.1]" data-id="element-169">
            Você já trabalha demais. <br data-id="element-170" />
            Trabalhar{' '}
            <span className="font-caveat text-rose text-[1.2em]" data-id="element-171">de graça</span>
            , nunca mais.
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-172">
          <p className="text-[15px] md:text-[19px] leading-[1.6] text-ink-soft max-w-2xl mx-auto mb-12" data-id="element-173">
            Você sabe que está deixando dinheiro na mesa. Você só não sabe
            quanto. Em menos de 5 minutos, o Aurora te mostra. E em 7 dias, se
            não fizer sentido pra você, devolvemos cada centavo.
          </p>
        </Reveal>

        <Reveal delay={0.2} data-id="element-174">
          <a href="#preco" className="cta-primary inline-flex items-center gap-3 bg-ink text-white pl-8 pr-2 py-2.5 rounded-full hover:bg-ink/90 transition-all hover:scale-105 mb-6 no-underline" data-id="element-175">
            <span className="font-medium text-base" data-id="element-176">
              Quero descobrir o meu número
            </span>
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center" data-id="element-177">
              <ArrowRight size={18} className="text-white" data-id="element-178" />
            </div>
          </a>
          <p className="text-[14px] text-ink-soft font-medium" data-id="element-179">
            🌸 Menos de R$1 por dia · Cancela quando quiser · 7 dias de garantia
            incondicional
          </p>
        </Reveal>
      </div>
    </section>;
};